import useUpdatePoolTaskSubmissions from '../../../../hooks/useUpdatePoolTaskSubmissions'
import TaskAllocationAmount from '../../../../shared_components/Missions/TaskAllocationAmount'
import SharedGraphIndexerTask, {
  Props,
} from '../../../../shared_components/Missions/Types/GraphIndexer'

export default function GraphIndexerTask(
  props: Omit<Props, 'updateTaskSubmissions' | 'taskAmount'>,
) {
  const updateTaskSubmissions = useUpdatePoolTaskSubmissions()
  return (
    <SharedGraphIndexerTask
      {...props}
      updateTaskSubmissions={updateTaskSubmissions}
      taskAmount={<TaskAllocationAmount taskId={props.taskId} />}
    />
  )
}
